import moment from "moment-timezone";
import { sendEventToGTM } from "../../sendEventToGTM";

export function sendBookingSearchStartedEvent({ searchQuery }) {
	const searchData = {
		type: searchQuery.type,
		adults: searchQuery.adults,
		children: searchQuery.children,
		infants: searchQuery.infants,
		currencyCode: searchQuery.currencyCode,
		returnMonth: undefined,
		returnYear: undefined,
		departureDate: undefined,
		returnDate: undefined,
		originIataCode: undefined,
		originAirportName: undefined,
		originCityName: undefined,
		originCountry: undefined,
		destinationIataCode: undefined,
		destinationAirportName: undefined,
		destinationCityName: undefined,
		destinationCountry: undefined,
	};

	if (searchQuery.type === "return") {
		const formattedReturnDate = moment.tz(
			searchQuery.returnDate,
			"YYYY-MM-DD",
			"UTC",
		);
		searchData.returnMonth = formattedReturnDate.month() + 1;
		searchData.returnYear = formattedReturnDate.year();
	}

	if (searchQuery.type === "multi-city") {
		searchData.departureDate = searchQuery.multiCityLegs[0].departureDate;
		searchData.returnDate =
			searchQuery.multiCityLegs[
				searchQuery.multiCityLegs.length - 1
			].departureDate;
		searchData.originIataCode = searchQuery.multiCityLegs[0].origin.id;
		searchData.originAirportName = searchQuery.multiCityLegs[0].origin.name;
		searchData.originCityName = searchQuery.multiCityLegs[0].origin.city;
		searchData.originCountry = searchQuery.multiCityLegs[0].origin.country;
		searchData.destinationIataCode =
			searchQuery.multiCityLegs[0].destination.id;
		searchData.destinationAirportName =
			searchQuery.multiCityLegs[0].destination.name;
		searchData.destinationCityName =
			searchQuery.multiCityLegs[0].destination.city;
		searchData.destinationCountry =
			searchQuery.multiCityLegs[0].destination.country;

		const formattedDepartureDate = moment.tz(
			searchQuery.multiCityLegs[0].departureDate,
			"YYYY-MM-DD",
			"UTC",
		);
		searchData.departureMonth = formattedDepartureDate.month() + 1;
		searchData.departureYear = formattedDepartureDate.year();

		const formattedReturnDate = moment.tz(
			searchQuery.multiCityLegs[searchQuery.multiCityLegs.length - 1]
				.departureDate,
			"YYYY-MM-DD",
			"UTC",
		);
		searchData.returnMonth = formattedReturnDate.month() + 1;
		searchData.returnYear = formattedReturnDate.year();
	} else {
		searchData.departureDate = searchQuery.departureDate;
		searchData.returnDate = searchQuery.returnDate;
		searchData.originIataCode = searchQuery.origin.id;
		searchData.originAirportName = searchQuery.origin.name;
		searchData.originCityName = searchQuery.origin.city;
		searchData.originCountry = searchQuery.origin.country;
		searchData.destinationIataCode = searchQuery.destination.id;
		searchData.destinationAirportName = searchQuery.destination.name;
		searchData.destinationCityName = searchQuery.destination.city;
		searchData.destinationCountry = searchQuery.destination.country;

		const formattedDepartureDate = moment.tz(
			searchQuery.departureDate,
			"YYYY-MM-DD",
			"UTC",
		);
		searchData.departureMonth = formattedDepartureDate.month() + 1;
		searchData.departureYear = formattedDepartureDate.year();
	}

	sendEventToGTM({
		event: "bookingSearchStarted",
		searchData,
	});
}
